/* Fantastick 8.0.0 — one session-scoped reference store for every motif view. */
(function (w) {
  'use strict';
  if (w.FantastickFavorites) return;
  const KEY = 'fantastick_motif_favorites_v1', EVENT = 'fantastick:favorites:changed';
  const valid = key => typeof key === 'string' && /^meta:[0-9]+$/.test(key);
  const clean = values => Array.isArray(values) ? [...new Set(values.filter(valid))] : [];
  const listeners = new Set();
  let memory = [], persistent = true;
  try { memory = clean(JSON.parse(w.sessionStorage.getItem(KEY) || '[]')); }
  catch (_) { /* Corrupt or unavailable storage: use a safe in-document list. */ }
  function getAll() { return memory.slice(); }
  function has(key) { return memory.includes(key); }
  function save(values) {
    const next = clean(values);
    if (JSON.stringify(next) === JSON.stringify(memory)) return getAll();
    memory = next;
    try { w.sessionStorage.setItem(KEY, JSON.stringify(memory)); persistent = true; }
    catch (_) { persistent = false; }
    const detail = { favorites: getAll(), persisted: persistent };
    listeners.forEach(callback => { try { callback(getAll()); } catch (e) { w.console && w.console.error('Fantastick favorites subscriber:', e); } });
    w.dispatchEvent(new CustomEvent(EVENT, { detail }));
    return getAll();
  }
  const api = {
    version: '8.0.0', key: KEY, getAll, has,
    add(key) { return valid(key) ? save(memory.concat(key)) : getAll(); },
    remove(key) { return save(memory.filter(value => value !== key)); },
    toggle(key) { return has(key) ? api.remove(key) : api.add(key); },
    clear() { return save([]); },
    subscribe(callback) { if (typeof callback !== 'function') return () => {}; listeners.add(callback); return () => listeners.delete(callback); },
    isPersistent() { return persistent; }, isValid: valid
  };
  // Same-origin frames in the same tab can receive a sessionStorage event.
  w.addEventListener('storage', event => {
    if (event.key !== KEY) return;
    try {
      const next = clean(JSON.parse(event.newValue || '[]'));
      if (JSON.stringify(next) === JSON.stringify(memory)) return;
      memory = next; listeners.forEach(callback => callback(getAll()));
      w.dispatchEvent(new CustomEvent(EVENT, { detail: { favorites: getAll(), persisted: true } }));
    } catch (_) { /* Ignore invalid writes by unrelated code. */ }
  });
  w.FantastickFavorites = api;
})(window);
